<script setup lang="ts">
const { variant, transform, forceFinalVariant } = useHeaderAnimation({
	headerHeightInPx: 80,
	variants: ['translucide', 'primary']
});
</script>

<template>
	<div class="min-h-screen">
		<PortalHeader
			:variant="variant"
			:transform="transform"
			class="fixed z-50 h-[60px] lg:h-20"
			@nav-option-being-shown="forceFinalVariant = true"
			@nav-option-closed="forceFinalVariant = false"
		/>

		<main>
			<slot />
		</main>

		<Container class="bg-primary-light-4 py-0">
			<NavigationSectionNavigation />
		</Container>

		<Container class="bg-primary py-0">
			<PortalFooter />
		</Container>
	</div>
</template>
